module.exports = __webpack_public_path__ + "img/38a20d1.jpg";